import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Tabs, Row, Col, Button, Empty, Statistic } from 'antd';
import { BankOutlined, TeamOutlined, ArrowRightOutlined } from '@ant-design/icons';
import TeamManagement from '../components/TeamManagement';
import api from '../utils/api';

const HostelAdminDashboard = () => {
  const [hostels, setHostels] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [activeTab, setActiveTab] = useState('hostels');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [hostelsRes, teamRes] = await Promise.all([
        api.get('/hostels'),
        api.get('/admin/team-members'),
      ]);
      setHostels(hostelsRes.data);
      setTeamMembers(teamRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const tabItems = [
    {
      key: 'hostels',
      label: (
        <span><BankOutlined /> My Hostels ({hostels.length})</span>
      ),
      children: (
        <Card>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
            <Statistic title="Total Hostels" value={hostels.length} />
            <Button type="primary" icon={<ArrowRightOutlined />} onClick={() => navigate('/hostels')}>
              Manage Hostels
            </Button>
          </div>
          {hostels.length === 0 ? (
            <Empty description="No hostels yet. Create your first hostel!" />
          ) : (
            <Row gutter={[16, 16]}>
              {hostels.slice(0, 6).map((hostel) => (
                <Col xs={24} sm={12} lg={8} key={hostel._id}>
                  <Card
                    hoverable
                    onClick={() => navigate(`/hostels/${hostel._id}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <Card.Meta
                      title={hostel.name}
                      description={
                        <>
                          <div>{hostel.address?.city}, {hostel.address?.country}</div>
                          <div style={{ marginTop: 8 }}>Rooms: {hostel.rooms?.length || 0}</div>
                        </>
                      }
                    />
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Card>
      ),
    },
    {
      key: 'team',
      label: (
        <span><TeamOutlined /> Employees ({teamMembers.length})</span>
      ),
      children: (
        <TeamManagement
          teamMembers={teamMembers}
          hostels={hostels}
          onRefresh={fetchData}
        />
      ),
    },
  ];

  if (loading) return null;

  return (
    <>
      <Card title={<span style={{ fontSize: 20, fontWeight: 600 }}>Owner Dashboard</span>}>
        <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} />
      </Card>
    </>
  );
};

export default HostelAdminDashboard;
